export const PUBLIC_ROUTE_PATHS = [
  'signup',
  'company-registration',
  'status',
  'xml-redirect',
  'network',
  'partners',
  'roadmap',
  '401',
  '404',
  '500',
  '503',
];

export function isPublicRoutePath(pathname: string): boolean {
  const pathWithoutQueryOrHash = pathname.split('?')[0].split('#')[0];
  const normalizedPath = pathWithoutQueryOrHash.replace(/\/+$/, '') || '/';

  return PUBLIC_ROUTE_PATHS.some(
    (routePath) => normalizedPath === `/${routePath}` || normalizedPath.startsWith(`/${routePath}/`),
  );
}
